import { useTheme } from '@mui/material/styles';
import { LineChart, Line, Tooltip, XAxis, YAxis, Label, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import Stack from '@mui/material/Stack';
import { CircleLegend } from '../../shared/CircleLegend';
import TooltipDiv from '../../shared/TooltipDiv';

function createData(time: string, Store674: number, Store435: number) {
  return { time, 'Store 674': Store674, 'Store 435': Store435 };
}

const data = [
  createData('Aug 1', 1400, 8000),
  createData('Aug 2', 2500, 12000),
  createData('Aug 3', 7300, 7000),
  createData('Aug 4', 8000, 11000),
  createData('Aug 5', 9000, 9000),
  createData('Aug 6', 10000, 11000),
];

export default function EventsChart() {
  const theme = useTheme();

  const renderLegend = (props: any) => {
    const { payload } = props;

    return (
      <Stack direction="row" sx={{ mt: '5px', ml: 27, mb: 4 }}>
        {
          payload.map((entry: any, i: number) => {
            return (
              <CircleLegend key={entry.dataKey} label={entry.dataKey} color={entry.color} />
            )
          })
        }
      </Stack>
    )
  }

  const EventTooltip = ({ active, label, payload }: any) => {
    
    if (active && payload && payload.length) {
      return (
        <TooltipDiv>
          <div>{label}</div>
          <div>{payload[0].value}</div>
        </TooltipDiv>
      );
    }

    return null;
  };

  return (
      <ResponsiveContainer height={316} width="99%">

        <LineChart data={data}
          height={300}
          margin={{
            top: 16,
            right: 16,
            bottom: 0,
            left: 0
          }}>
          <Tooltip
            itemStyle={{
              fontSize: '0.8rem',
              fontFamily: 'Montserrat',
              color: theme.palette.text.primary
            }}
            content={EventTooltip}
            cursor={{ stroke: theme.palette.text.primary, strokeWidth: 2, strokeDasharray: "1 4" }}
          />
          <XAxis
            dataKey="time"
            stroke={theme.palette.text.primary}
            tickLine={false}
            dy={5}
            strokeDasharray="1 4"
            tickMargin={10}
            height={40}
            style={{
              fontSize: '0.8rem',
              fontFamily: 'Montserrat',
            }}
            padding={{ left: 70, right: 70 }}
          />
          <YAxis
            stroke={theme.palette.text.primary}
            tickLine={false}
            axisLine={false}
            dx={-10}
            style={{
              fontSize: '0.8rem',
              fontFamily: 'Montserrat',
            }}
          >
            <Label
              angle={270}
              offset={10}
              position="left" />
          </YAxis>
          <CartesianGrid stroke={theme.palette.text.primary} strokeDasharray="1 4" vertical={false} />
          <Line
            type="monotone"
            dataKey="Store 674"
            stroke={theme.palette.text.secondary}
            strokeWidth={5}
            dot={false}
            fill="url(#linear)"
          />
          <Legend verticalAlign="top" content={renderLegend} />
        </LineChart>
      </ResponsiveContainer>
  );
}